export default function CloseIcon({ size = 24, ...props }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2779 0.29535L0.29535 10.2779C-0.09845 10.6717 -0.09845 11.3102 0.29535 11.704C0.68915 12.0978 1.32763 12.0978 1.72143 11.704L11.704 1.72143C12.0978 1.32763 12.0978 0.68915 11.704 0.29535C11.3102 -0.0984501 10.6717 -0.0984499 10.2779 0.29535Z"
        fill="currentColor"
      />
      <path
        d="M11.7046 10.278L1.72212 0.295468C1.32832 -0.0983317 0.689844 -0.0983317 0.296044 0.295468C-0.0977559 0.689268 -0.0977559 1.32774 0.296044 1.72154L10.2786 11.7041C10.6724 12.0979 11.3108 12.0979 11.7046 11.7041C12.0984 11.3103 12.0984 10.6718 11.7046 10.278Z"
        fill="currentColor"
      />
    </svg>
  );
}
